// =============================================================================
// components/KpiRules/KpiRulesPage.jsx
// Página principal de gestão de regras de deteção de anomalias de KPI.
// =============================================================================
import { useEffect } from 'react';
import { Box, Grid, Paper, Typography, Alert, Snackbar } from '@mui/material';
import TuneIcon from '@mui/icons-material/Tune';

import { useKpiRules } from '../../hooks/useKpi';
import KpiRuleList    from './KpiRuleList';
import KpiRuleForm    from './KpiRuleForm';
import EngineLog      from './EngineLog';

export default function KpiRulesPage() {
  const {
    items, loading,
    selectedRule, saving, saveError, saveSuccess,
    validation, rulesByTech,
    load, save, remove, select, openNew, validate, clearVal,
  } = useKpiRules();

  useEffect(() => { load(); }, []); // eslint-disable-line

  const handleCancel = () => { select(null); clearVal(); };

  return (
    <Box sx={{ p: 3 }}>
      {/* Cabeçalho ---------------------------------------------------- */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 3 }}>
        <TuneIcon color="primary" />
        <Box>
          <Typography variant="h5" fontWeight={700}>
            Regras de Deteção de KPI
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Defina, por KPI, a partir de que dados e com que critérios o motor deve abrir incidentes.
          </Typography>
        </Box>
      </Box>

      <Grid container spacing={2.5}>
        {/* Coluna esquerda — lista de regras --------------------------- */}
        <Grid item xs={12} md={4}>
          <Paper variant="outlined" sx={{ height: '78vh', display: 'flex', flexDirection: 'column' }}>
            <KpiRuleList
              rulesByTech={rulesByTech}
              totalCount={items.length}
              loading={loading}
              selectedId={selectedRule?.kpiId}
              onSelect={select}
              onCreate={openNew}
            />
          </Paper>
        </Grid>

        {/* Coluna direita — formulário + histórico do motor ------------ */}
        <Grid item xs={12} md={8}>
          <Paper variant="outlined" sx={{ p: 3, mb: 2.5 }}>
            {selectedRule ? (
              <KpiRuleForm
                rule={selectedRule}
                saving={saving}
                saveError={saveError}
                validation={validation}
                onSave={save}
                onCancel={handleCancel}
                onValidate={validate}
                onDelete={remove}
              />
            ) : (
              <Box sx={{ textAlign: 'center', py: 6 }}>
                <TuneIcon sx={{ fontSize: 32, color: 'text.disabled', mb: 1 }} />
                <Typography variant="body2" color="text.secondary">
                  Selecione uma regra à esquerda para editar, ou clique em "Nova Regra".
                </Typography>
              </Box>
            )}
          </Paper>

          <EngineLog />
        </Grid>
      </Grid>

      <Snackbar
        open={saveSuccess}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert severity="success" variant="filled">Regra guardada com sucesso.</Alert>
      </Snackbar>
    </Box>
  );
}
